import { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Globe } from "lucide-react";

export default function PublicDomainCard() {
  const [d, setD] = useState(null);
  const [url, setUrl] = useState("");
  const load = () => api.get("/settings/public-domain").then((r) => { setD(r.data); setUrl(r.data.url); }).catch(() => {});
  useEffect(() => { load(); }, []);
  const save = async (value) => {
    try { const { data } = await api.put("/settings/public-domain", { url: value }); setD(data); setUrl(data.url); toast.success(value ? `Odkazy a QR kódy nyní vedou na ${value}` : "Vráceno na výchozí adresu"); }
    catch (e) { toast.error(apiErr(e)); }
  };
  if (!d) return null;
  const active = !!d.url;
  return (
    <div className="bg-white rounded-xl border p-5 space-y-3" data-testid="public-domain-card">
      <h3 className="font-semibold text-[#0A2540] flex items-center gap-2"><Globe className="h-4 w-4" /> Veřejná doména pro obyvatele</h3>
      <p className="text-sm text-slate-500">Adresa, kterou obsahují letáky, QR kódy, e-maily a pozvánky. Aktuálně: <code className="text-[#0A2540]" data-testid="public-domain-effective">{d.effective}</code>{active ? "" : " (výchozí)"}</p>
      <div className="flex flex-wrap gap-2 items-center">
        <Input value={url} onChange={(e) => setUrl(e.target.value)} placeholder={d.suggested} className="w-72" data-testid="public-domain-input" />
        <Button onClick={() => save(url)} disabled={url === d.url} style={{ background: "#0A2540" }} data-testid="public-domain-save">Uložit</Button>
        {!active && <Button variant="outline" onClick={() => save(d.suggested)} data-testid="public-domain-preset">Použít {d.suggested.replace("https://", "")}</Button>}
        {active && <Button variant="ghost" onClick={() => save("")} data-testid="public-domain-reset">Vrátit výchozí</Button>}
      </div>
      <p className="text-xs text-slate-500">Po nákupu domény ji v nasazení (Deploy → Custom domain) namiřte na tuto aplikaci a zde ji zapněte – všechny nové letáky a QR kódy budou hned fungovat. Stávající vytištěné QR kódy s původní adresou zůstávají platné, dokud běží i původní adresa.</p>
    </div>
  );
}
